/** "1 day", "3 days", "2 addresses": a count and the noun that agrees with it. */
export const plural = (n: number, one: string, many = `${one}s`) => `${n} ${n === 1 ? one : many}`;
